module.exports = __webpack_public_path__ + "static/img/manual-2.fad071c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/en/manual-2.png
// module id = 5sc7
// module chunks = 4